export default class HallEntrance {

    static COMPONENT_NAME = "nf.hallEntrance";

    inputs = {
        model: null,
        href: null,
    };

    events = {
        "INTERACTION.CLICK": true,
        "INTERACTION.HOVER": false,
        "INTERACTION.DRAG": false,
    };

    onInit() {
        const THREE = this.context.three;

        this.root = new THREE.Object3D();
        this.outputs.objectRoot = this.root;
        this.outputs.collider   = this.root;

        this.loadModel();
    }

    loadModel() {
        const THREE = this.context.three;
        const loader = new THREE.GLTFLoader();

        const url = resolveUrl(this.inputs.model);

        loader.load(url, gltf => {
            this.root.add(gltf.scene);
        });
    }

    onEvent(interaction) {
        switch (interaction) {
            case "INTERACTION.CLICK":
                this.onClick();
                break;
        }
    }

    onClick() {
        window.location.href = this.inputs.href;
    }

}

function resolveUrl(url) {
    return (new URL(url, window.location.href)).toString();
}
